export default "__VITE_ASSET__BzeG85D2__"